export const SET_PROCEDURE = 'SET_PROCEDURE';
export const SET_PROCEDURES = 'SET_PROCEDURES';
export const SET_PROCEDURES_QUERY_PARAMS = 'SET_PROCEDURES_QUERY_PARAMS';
export const SET_PROCEDURES_SET_IS_FETCHING = 'SET_PROCEDURES_SET_IS_FETCHING';

export const SET_DICTPROCEDURE = 'SET_DICTPROCEDURE';
export const SET_DICTPROCEDURES = 'SET_DICTPROCEDURES';
export const SET_DICTPROCEDURES_QUERY_PARAMS = 'SET_DICTPROCEDURES_QUERY_PARAMS';
export const SET_DICTPROCEDURES_SET_IS_FETCHING = 'SET_DICTPROCEDURES_SET_IS_FETCHING';
